import React from "react";

function Social(props) {
  return (
    <div className="Social">
      <p className="Social_title">Redes Sociales</p>
      <div className="SocialIcons">
        <div> <a className="facebook icon"  href="https://www.facebook.com/contactaabogado/" target="_blank"/> </div>
        <div> <a className="linked-in icon" href="https://www.linkedin.com/company/contactaabogado" target="_blank"/> </div>
        <div> <a className="instagram icon" href="https://www.instagram.com/contactaabogado_/" target="_blank"></a> </div>
        {/* <div className="you-tube icon"></div>
        </div>href="https://www.facebook.com/contactaabogado/" target="_blank"
        {/* <div className="instagram icon"></div> */}
        {/* <div className="you-tube icon"></div>
        </div> 
        <a className="linked-in icon" href="https://www.linkedin.com/company/contactaabogado" target="_blank"/>
        {/* <div className="you-tube icon"></div>
        <div className="twitter icon"></div> */}
      </div>
      <div className="Social_container">
        <a className="Social_signin" href="/ingreso-abogados">¿Eres abogado? Ingresa aquí</a>
{/*         <a className="Social_badgeContainer"><span className="Social_nobadge">Membresías</span><span className="Social_badge">PARA PROFESIONALES</span></a>
 */}      </div>
    </div>
  );
}

export default Social;
